import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

import { AuthService } from './services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private authService: AuthService,
        private router: Router
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const sessionHash = this.authService.getSessionHash();

        const authReq = sessionHash
            ? req.clone({ headers: req.headers.set('X-Session-Hash', sessionHash) })
            : req;

        return next.handle(authReq).pipe(
            tap(
                () => { },
                (err: any) => {
                    if (err instanceof HttpErrorResponse && err.status === 401) {
                        this.authService.clearSession();
                        this.router.navigate(['/home']);
                    }
                }
            )
        );
    }
}
